import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes2";
import useTable from "../../components/useTable";
import { Dimmer } from "../../components/spinner";
import { IncluirProducOper } from "./incluirProducto";
import { validaSoloNumero, formatMoneda } from "../../util/varios";
import moment from "moment";
import CatalogoAlmacen from "../../catalogos/catalogoAlmacen";

import CatalogoOperacionesInventario from "../../catalogos/catalogoOperacionesInventario";
import { SearchInput, Textarea, Input, Select } from "../../ui/inputs/Input";
import {
  DangerButton,
  InfoButton,
  PrimaryButton,
  SuccessButton,
  WarningButton,
} from "../../ui/buttons/Button";
import e from "cors";

const TablaOperInventario = () => {
  const op = require("../../../src/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const organizacion = JSON.parse(localStorage.getItem("riforganizacion"));
  const accbtnopinventario = 1111; 
  const almacensel = JSON.parse(localStorage.getItem('idalmacen'));
  /* JSON.parse(
        localStorage.getItem("accbtnopinventarioc")
    ); */
  const fechaSistema = moment.utc(
    JSON.parse(localStorage.getItem("fechasistema"))
  ).format("YYYY-MM-DD");

  const headCells = [
    {
      label: "COD.",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
      width: "40px",
    },
    {
      label: "PRODUCTO",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
      width: "50px",
    },
    {
      label: "CANTIDAD",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
      width: "30px",
    },

    {
      label: "FECHA VEN.",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
      width: "50px",
    },
    {
      label: "TIPO MOVIMIENTO",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
      width: "50px",
    },
    {
      label: "FECHA",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
      width: "50px",
    },
    {
      label: "N° FACTURA",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
      width: "50px",
    },
    {
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
      label: <i className="fas fa-trash" />,
      textAlign: "center",
      width: "20px",
    },
  ];

  const btnIncluir = useRef();
  const btnEditar = useRef();
  const btnEliminar = useRef();
  const btnConsultar = useRef();
  const btnCancelar = useRef();
  const btnAceptar = useRef();

  const txtIdOpeInv = useRef();
  const txtFecha = useRef();
  const txtCodAlmaOrigen = useRef();
  const txtDescripAlmaOrigen = useRef();
  const txtCodAlmaDestino = useRef();
  const txtDescripAlmaDestino = useRef();
  const txtObservacion = useRef();
  const cmbTipoOperacion = useRef();
  const cmbMoneda = useRef();
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [tituloHeader, setTituloHeader] = useState(
    "Gestionar Operaciones de Inventario."
  );

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [habilitarCat, setHabilitarCat] = useState(true);
  const [habilitado, setHabilitado] = useState(false);
  const [habilitadoM, setHabilitadoM] = useState(false);
  const [habilitarMoneda, setHabilitarMoneda] = useState(false);
  const [operacion, setOperacion] = useState(1);
  const [catalogoOpeInv, setCatalogoOpeInv] = useState(false);
  const [catalogoAlmacen, setCatalogoAlmacen] = useState(false);
  const [cualCat, setCualCat] = useState(1);
  const [body, setBody] = useState(null);
  const [visibleAlma, setVisibleAlma] = useState("hidden");
  const [idProd, setIdPro] = useState(0);
  const [desde, setDesde] = useState(0);
  const [regDet, setRegDet] = useState();

  const [mostrar, setMostrar] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacionOper, setOperacionOper] = useState();
  const [records, setRecords] = useState([]);
  const [combomoneda] = useState([]);
  const [moneda, setMoneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [monedaSub] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 0.0,
  });
  const [monedaCambio, setMonedaCambio] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });

  const [tipoIngreso, setTipoIngreso] = useState([]);

  const { TblContainer, TblHead } = useTable(records, headCells, {
    fn: (items) => {
      return items;
    },
  });

  const seleccionarRegistro = (id) => {
    console.log("este es el id", id);
    let campos = "*";
    let nomtab = "operacioninventario";
    let nomid = "idoperacioninventario";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            if (response.data.idalmacenorigen === almacensel ) {
              txtIdOpeInv.current.setAttribute("disabled", true);
              setHabilitarCat(true);
              txtIdOpeInv.current.value = id;
              txtFecha.current.value = moment.utc(response.data.fecha).format(
                "YYYY-MM-DD"
              );
              txtObservacion.current.value = response.data.observacion.trim();
              if (response.data.tipooperacion === "INGRESO") {
                cmbTipoOperacion.current.value = "1";
              } else if (response.data.tipooperacion === "SALIDA") {
                cmbTipoOperacion.current.value = "2";
              } else if (response.data.tipooperacion === "TRASLADO") {
                cmbTipoOperacion.current.value = "3";
              }

              llenarTipoIngreso(parseInt(cmbTipoOperacion.current.value));

              seleccionarAlmacen(13, response.data.idalmacenorigen, 1);
              //txtCodAlmaOrigen.current.value = response.data.idalmacenorigen;
              if (response.data.idalmacendestino === null) {
                setVisibleAlma("hidden");
                //txtCodAlmaDestino.current.value = "";
              } else {
                setVisibleAlma("visible");
                txtCodAlmaDestino.current.value = response.data.idalmacendestino;
                seleccionarAlmacen(13, response.data.idalmacendestino, 2);
              }
              // seleccionarMoneda(response.data.idmoneda);
              seleccionarDetalle();
              for (let i = 0; i < combomoneda.length; i++) {
                if (response.data.idmoneda === combomoneda[i].idmoneda) {
                  cmbMoneda.current.selectedIndex = i;
                  break;
                }
              }
              if (operacion === 2) {
                setHabilitado(true);
                setHabilitarMoneda(true);
                setTimeout(() => txtFecha.current.focus(), 200);
              } else {
                setTimeout(() => btnCancelar.current.focus(), 200);
              }
            } else {
              setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "ID no existe para el almacen seleccionado.",
              icono: "informacion",
              });
              txtIdOpeInv.current.value = "";
              txtIdOpeInv.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "ID no existe.",
              icono: "informacion",
            });
            txtIdOpeInv.current.value = "";
            txtIdOpeInv.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarDetalle = () => {
    let nomtab = "operacioninventariodetalle";
    let nomid = "idoperacioninventario";
    let id = txtIdOpeInv.current.value;
    let endpoint = `${op.conexion}/api/comprasAlmacen/selectdetalleopeinv?nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let prod = [];
            for (let i = 0; i < response.data.length; i++) {
              if (
                response.data[i].idalmacen === txtCodAlmaOrigen.current.value
              ) {
                let cantie = response.data[i].cantidade;

                if (response.data[i].tipounidad === 0) {
                  if (response.data[i].tipofactor === "1") {
                    cantie = parseFloat(
                      response.data[i].cantidade / response.data[i].valorfactor
                    );
                    cantie = Math.trunc(cantie);
                  }
                } else {
                  if (response.data[i].tipofactor === "0") {
                    cantie = parseFloat(
                      response.data[i].cantidade / response.data[i].valorfactor
                    );
                    cantie = Math.trunc(cantie);
                  }
                }

                prod.push({
                  idproducto: response.data[i].idproducto,
                  codigo: response.data[i].idproducto,
                  descripcion: response.data[i].descripcion,
                  cantidad:
                    response.data[i].cantidad < 0
                      ? response.data[i].cantidad * -1
                      : response.data[i].cantidad,
                  precio: response.data[i].precio,
                  fechavencimiento:
                    response.data[i].fechavencimiento === null
                      ? ""
                      : response.data[i].fechavencimiento,
                  tipomovimiento: response.data[i].tipomovimiento,
                  fechatipomovimiento:
                    response.data[i].fechatipomovimiento === null
                      ? ""
                      : response.data[i].fechatipomovimiento,
                  numfactura: response.data[i].numfactura,
                  tipounidad: response.data[i].tipounidad,
                  idmoneda: response.data[i].idmoneda,
                  idunidadmedida: response.data[i].idunidadmedida,
                  idunidadalterna: response.data[i].idunidadalterna,
                  descripcionuni: response.data[i].descripcionuni,
                  descripcionunialt: response.data[i].descripcionunialt,
                  preciomaxi: response.data[i].preciomaxi,
                  precioofe: response.data[i].precioofe,
                  preciomayor: response.data[i].preciomayor,
                  preciomini: response.data[i].preciomini,
                  preciomaxialter: response.data[i].preciomaxialter,
                  precioofealter: response.data[i].precioofealter,
                  preciomayoralter: response.data[i].preciomayoralter,
                  preciominialter: response.data[i].preciominialter,
                  tipofactor: response.data[i].tipofactor,
                  valorfactor: response.data[i].valorfactor,
                  valormoneda: response.data[i].valormoneda,
                  idubicacion: response.data[i].idubicacion,
                  idubicaciondest: response.data[i].idubicaciondest,
                });
              }
            }
            setRecords(prod);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarAlmacen = (tecla, cod, llamado) => {
    let campos = "*";
    let nomtab = "almacen";
    let nomid = "idalmacen";
    let id = cod;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            if (llamado === 1) {
              txtCodAlmaOrigen.current.value = cod;
              txtDescripAlmaOrigen.current.value = response.data.descripcion.trim();
              if (cmbTipoOperacion.current.value === "3" && tecla === 13  ) {
                txtCodAlmaDestino.current.focus();
              } else if (tecla === 13) {
                btnAceptar.current.focus();
              }
            } else {
              if (txtCodAlmaOrigen.current.value === cod) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificación",   
                  texto: "El Almacen Destino no puede ser igual al Origen",
                  icono: "informacion",
                });
                txtCodAlmaDestino.current.value = "";
              } else  {
                txtCodAlmaDestino.current.value = cod;
                txtDescripAlmaDestino.current.value = response.data.descripcion.trim();
                if (tecla === 13){
                  btnAceptar.current.focus();
                }
              } 

            }
          } else {
            if (llamado === 1) {
              txtCodAlmaOrigen.current.value = "";
              txtCodAlmaOrigen.current.focus();
            } else {
              txtCodAlmaDestino.current.value = "";
              txtCodAlmaDestino.current.focus();
            }
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "El Almacen no esxite",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        if (llamado === 1) {
          txtCodAlmaOrigen.current.value = "";
          txtCodAlmaOrigen.current.focus();
        } else {
          txtCodAlmaDestino.current.value = "";
          txtCodAlmaDestino.current.focus();
        }
      });
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/comprasAlmacen/actoperinv`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " + response.data[0].idopeinv + " creado correctamente",
              icono: "exito",
            });
            window.open(
              op.reportes +
                `/almacen?afiliado=${organizacion}&reporte=ReporteDetaOpeInventario&codigo=${response.data[0].idopeinv}`,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            );
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data[0].idopeinv +
                " modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " +
                response.data[0].idopeinv +
                " eliminado correctamente",
              icono: "exito",
            });
          }
          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          mensaje = error.response.data.message;
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const gestionOper = (op, id, index) => (e) => {
    e.preventDefault();
    setOperacionOper(op);
    if (op === 1) {
      if (txtCodAlmaOrigen.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar el almacen",
          icono: "informacion",
        });
        txtCodAlmaOrigen.current.focus();
        return;
      } else if (parseInt(cmbTipoOperacion.current.value) === 3 && txtCodAlmaDestino.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe seleccionar el almacen destino",
          icono: "informacion",
        });
        txtCodAlmaDestino.current.focus();
        return;
      }
      setMostrar(true);
    } else if (op === 2) {
      setRegDet(records[index]);
      setMostrar(true);
    } else if (op === 3) {
      setIdPro(id);
      setDesde(1);
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Esta seguro de eliminar el registro?",
        icono: "confirmacion",
      });
    }
  };

  const closeGestionOper = (op) => {
    setMostrar(false);
  };

  const closeAceptarGestionOper = (datos) => {
    let prod = [];
    console.log(datos);
    for (let i = 0; i < records.length; i++) {
      prod.push({
        idproducto: records[i].idproducto,
        codigo: records[i].idproducto,
        descripcion: records[i].descripcion,
        cantidad: records[i].cantidad,
        precio: records[i].precio,
        fechavencimiento: records[i].fechavencimiento,
        tipomovimiento: records[i].tipomovimiento,
        fechatipomovimiento: records[i].fechatipomovimiento,
        numfactura: records[i].numfactura,
        tipounidad: records[i].tipounidad,
        idmoneda: records[i].idmoneda,
        idunidadmedida: records[i].idunidadmedida,
        idunidadalterna: records[i].idunidadalterna,
        descripcionuni: records[i].descripcionuni,
        descripcionunialt: records[i].descripcionunialt,
        tipofactor: records[i].tipofactor,
        valorfactor: records[i].valorfactor,
        valormoneda: records[i].valormoneda,
        idubicacion: records[i].idubicacion,
        idubicaciondest: records[i].idubicaciondest,
      });
    }

    console.log("datos.valorfactor => " + datos.valorfactor);

    prod.push({
      idproducto: datos.idproducto,
      codigo: datos.idproducto,
      descripcion: datos.descripcion,
      cantidad: datos.cantidad,
      precio: datos.precio,
      fechavencimiento: datos.fechavencimiento,
      tipomovimiento: datos.tipomovimiento,
      fechatipomovimiento: datos.fechatipomovimiento,
      numfactura: datos.numfactura,
      idmoneda: datos.idmoneda,
      tipounidad: datos.tipounidad,
      idunidadmedida: datos.idunidadmedida,
      idunidadalterna: datos.idunidadalterna,
      descripcionuni: datos.descripcionuni,
      descripcionunialt: datos.descripcionunialt,
      tipofactor: datos.tipofactor,
      valorfactor: datos.valorfactor,
      valormoneda: datos.valormoneda,
      idubicacion: datos.idubicacion,
      idubicaciondest: datos.idubicaciondest,
    });
    setMostrar(false);
    setRecords(prod);
  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (desde === 1) {
      var prod = records;
      var prod = prod.filter(function (prod) {
        return prod.idproducto !== idProd;
      });
      setDesde(0);
      setRecords(prod);
    } else if (desde === 2) {
      setDesde(0);
      procesarRegistro();
    }
    /*  getExpendedor(); */
  };

  const handleInputNumeroChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.target.name === "codalmaorigen") {
      txtDescripAlmaOrigen.current.value = "";
      setRecords([]);
    } else if (event.target.name === "codalmadestino") {
      txtDescripAlmaDestino.current.value = "";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "idopeinv") {
          seleccionarRegistro(event.target.value);
        } else if (event.target.name === "codalmaorigen") {
          seleccionarAlmacen(event.which, event.target.value, 1);
        } else if (event.target.name === "codalmadestino") {
          seleccionarAlmacen(event.which, event.target.value, 2);
        }
      }
    }
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.which === 13) {
      if (event.target.name === "fechaope") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
        cmbTipoOperacion.current.focus();
      } else if (event.target.name === "codalmaorigen") {
      } else if (event.target.name === "codalmadestino") {
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.name === "fechaope") {
        event.target.value = moment.utc(event.target.value).format("YYYY-MM-DD");
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (
        accbtnopinventario &&
        accbtnopinventario.toString().substring(0, 1) === "1"
      ) {
        setTituloHeader("Incluir Operacion de Inventario.");
        setVisibleBtn("hidden");
        setHabilitadoBot(false);
        setOperacion(op);
        setHabilitadoM(true);
        setHabilitado(true);
        setHabilitarMoneda(true);
        txtIdOpeInv.current.value = "0";
        txtIdOpeInv.current.setAttribute("disabled", true);
        setHabilitarCat(true);
        txtFecha.current.value = fechaSistema;
        cmbTipoOperacion.current.selectedIndex = 0;
        llenarTipoIngreso(1);
        setTimeout(() => txtFecha.current.focus(), 200);
        //txtCodAlmaOrigen.current.value = almacensel;
        seleccionarAlmacen(13, almacensel, 1);
      } else {
        setHabilitadoBot(true);
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (
        accbtnopinventario &&
        accbtnopinventario.toString().substring(1, 2) === "1"
      ) {
        setVisibleBtn("hidden");
        setTituloHeader("Editar Operacion de Inventario.");
        setOperacion(op);
        setHabilitadoBot(false);
        txtIdOpeInv.current.removeAttribute("disabled");
        setHabilitarCat(false);
        setHabilitadoM(false);
        setHabilitado(false);
        seleccionarAlmacen(1, almacensel, 1);
        txtIdOpeInv.current.focus();
      } else {
        setHabilitadoBot(true);
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (
        accbtnopinventario &&
        accbtnopinventario.toString().substring(3, 4) === "1"
      ) {
        setTituloHeader("Eliminar Operacion de Inventario.");
        setVisibleBtn("hidden");
        setOperacion(op);
        setHabilitadoBot(false);
        txtIdOpeInv.current.removeAttribute("disabled");
        setHabilitarCat(false);
        setHabilitarMoneda(false);
        setHabilitadoM(false);
        setHabilitado(false);
        seleccionarAlmacen(1, almacensel, 1);
        txtIdOpeInv.current.focus();
      } else {
        setHabilitadoBot(true);
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (
        accbtnopinventario &&
        accbtnopinventario.toString().substring(2, 3) === "1"
      ) {
        setTituloHeader("Consultar Operacion de Inventario.");
        setVisibleBtn("hidden");
        setOperacion(op);
        setHabilitadoM(false);
        setHabilitado(false);
        setHabilitarMoneda(true);
        setHabilitadoBot(false);
        txtIdOpeInv.current.removeAttribute("disabled");
        setHabilitarCat(false);
        seleccionarAlmacen(1, almacensel, 1);
        txtIdOpeInv.current.focus();
      } else {
        setHabilitadoBot(true);
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      if (operacion !== 4) {
        onChangeValidar();
      }
    } else if (op === 6) {
      setVisibleBtn("visible");
      blanquear();
    } else if (op === 7) {
      //setCatalogoProducto(true);
    }
  };

  const blanquear = () => {
    setTituloHeader("Gestionar Operaciones de Inventario.");

    setActivate(false);
    setBody(null);
    setHabilitado(false);
    setHabilitadoM(false);
    setHabilitadoBot(true);
    setHabilitarMoneda(false);
    txtIdOpeInv.current.setAttribute("disabled", true);
    setHabilitarCat(true);

    //btnBuscar.current.setAttribute("disabled", true);
    txtIdOpeInv.current.value = "";
    txtFecha.current.value = "";
    txtObservacion.current.value = "";
    txtCodAlmaOrigen.current.value = "";
    txtDescripAlmaOrigen.current.value = "";
    if (cmbTipoOperacion.current.value === "3") {
      txtCodAlmaDestino.current.value = "";
      txtDescripAlmaDestino.current.value = "";
    }
    cmbTipoOperacion.current.selectedIndex = -1;
    setMoneda({
      idmoneda: "1",
      descripcion: "BOLIVARES",
      simbolo: "Bs",
      predeterminada: false,
      valormoneda: 1.0,
    });
    setMonedaCambio({
      idmoneda: "4",
      descripcion: "DOLAR",
      simbolo: "$",
      predeterminada: false,
      subpredeterminada: true,
      valormoneda: 1.0,
    });
    for (let i = 0; i < combomoneda.length; i++) {
      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
        cmbMoneda.current.selectedIndex = i;
      }
    }
    setVisibleAlma("hidden");
    setRecords([]);
    setVisibleBtn("visible");
  };

  const llenarTipoIngreso = (tipoing) => {
    let tipo = [];
    if (tipoing === 1) {
      setVisibleAlma("hidden");

      tipo.push({
        idtipo: "1",
        descripcion: "INVENTARIO INICIAL",
      });
      tipo.push({
        idtipo: "2",
        descripcion: "DONACIÓN",
      });
      tipo.push({
        idtipo: "3",
        descripcion: "PRESTAMO",
      });
      tipo.push({
        idtipo: "4",
        descripcion: "RESGUARDO",
      });
      tipo.push({
        idtipo: "5",
        descripcion: "COMPRA",
      });
      tipo.push({
        idtipo: "6",
        descripcion: "PRODUCCIÓN",
      });
      tipo.push({
        idtipo: "7",
        descripcion: "AJUSTE",
      });
    } else if (tipoing === 2) {
      tipo.push({
        idtipo: "1",
        descripcion: "VENTA",
      });
      tipo.push({
        idtipo: "2",
        descripcion: "VENCIMIENTO",
      });
      tipo.push({
        idtipo: "3",
        descripcion: "DEVOLUCION",
      });
      tipo.push({
        idtipo: "4",
        descripcion: "PRESTAMO",
      });
      tipo.push({
        idtipo: "5",
        descripcion: "DONACIÓN",
      });
      tipo.push({
        idtipo: "6",
        descripcion: "AJUSTE",
      });
      setVisibleAlma("hidden");
    } else if (tipoing === 3) {
      tipo.push({
        idtipo: "1",
        descripcion: "TRASLADO",
      });
      setVisibleAlma("visible");
    }
    setTipoIngreso(tipo);
  };

  const onChange = (e) => {
    if (e.target.name === "tipoopeinv") {
      if (e.target.value === "3") {
        setVisibleAlma("visible");
      } else {
        setVisibleAlma("hidden");
      }
      llenarTipoIngreso(parseInt(e.target.value));
    } else if (e.target.name === "fechaope") {
    }
  };

  const onCatalogoOperacionInv = (values) => {
    setCatalogoOpeInv(false);

    seleccionarRegistro(values);
  };

  const onChangeMoneda = (e) => {
    let i = e.target.value;

    setMonedaCambio(cambio.monedacambio);
  };

  const onCatalogoAlmacen = (values) => {
    setCatalogoAlmacen(false);
    if (cualCat === 1) {
      txtCodAlmaOrigen.current.value = values.idalmacen;
      //txtDescripUbiOrigen.current.value = values.descripcion.trim() + ' Almacen: ' + response.data[0].descripcion.trim();
    } else {
      txtCodAlmaDestino.current.value = values.idalmacen;
      //txtDescripUbiDestino.current.value = values.descripcion;
    }
    seleccionarAlmacen(13, values, cualCat);
  };

  const onChangeValidar = () => {
    var sigue = true;

    if (txtIdOpeInv.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtIdOpeInv.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtObservacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Observación no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (txtCodAlmaOrigen.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código del Almacen no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCodAlmaOrigen.current.focus();
    } else if (
      cmbTipoOperacion.current.value === "3" &&
      txtCodAlmaDestino.current.value.trim() === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código del Almacen Destino no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtCodAlmaDestino.current.focus();
    } else if (
      cmbTipoOperacion.current.value === "3" &&
      txtCodAlmaOrigen.current.value.trim() ===
        txtCodAlmaDestino.current.value.trim()
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Código del Almacen Oriregen y Destino no deben ser iguales",
        icono: "informacion",
      });
      sigue = false;
      txtCodAlmaDestino.current.focus();
    } else if (records.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No hay Producto agregados",
        icono: "informacion",
      });
      sigue = false;
      btnCancelar.current.focus();
    }

    if (sigue) {
      var opeinv = [];
      var opeinvdet = [];

      opeinv.push({
        idoperacioninventario: txtIdOpeInv.current.value,
        tipooperacion:
          cmbTipoOperacion.current[cmbTipoOperacion.current.selectedIndex].text,
        idalmacenorigen: txtCodAlmaOrigen.current.value,
        idalmacendestino:
          cmbTipoOperacion.current.value === "3"
            ? txtCodAlmaDestino.current.value
            : "",
        fecha: txtFecha.current.value,
        idmoneda: monedaSub.idmoneda,
        observacion: txtObservacion.current.value,
      });

      for (let i = 0; i < records.length; i++) {
        opeinvdet.push({
          idproducto: records[i].idproducto,
          descripcion: records[i].descripcion,
          cantidad: records[i].cantidad,
          precio: records[i].precio,
          fechavencimiento: records[i].fechavencimiento,
          tipomovimiento: records[i].tipomovimiento,
          fechatipomovimiento: records[i].fechatipomovimiento,
          numfactura: records[i].numfactura,
          idalmacen: txtCodAlmaOrigen.current.value,
          tipounidad: records[i].tipounidad,
          idunidadmedida: records[i].idunidadmedida,
          idubicacion: records[i].idubicacion,
          idubicaciondest:
            cmbTipoOperacion.current.value === "3"
              ? records[i].idubicaciondest
              : null,   
        });
      }

      setBody({
        operacion: operacion,
        idtipopeinv: cmbTipoOperacion.current.value,
        opeinv: opeinv,
        opeinvdet: opeinvdet,
      });
      setDesde(2);
      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const imprimirReporte = () => {
  
    window.open(
            `${op.reportes}/comprasyalmacen?reporte=ReporteDetaOpeInventario&codigo=${txtIdOpeInv.current.value}`,
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

  };

  useEffect(() => {
    if (cmbTipoOperacion) {
      cmbTipoOperacion.current.selectedIndex = -1;
    }
  }, []);

  return (
    <div className="col-8 m-0 mx-auto mt-5 p-2 d-flex flex-column align-items-center justify-content-center border rounded">
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
        <h3 className="m-0 fw-bold">{tituloHeader}</h3>
        <a href="/inicio" className="text-light fw-bold fs-6">
            Salir<i className="fas fa-times ms-2"></i>
        </a>
        </header>

        <div className="col-12 m-0 p-0 py-2 d-flex flex-wrap">
        <div className="col-4 m-0 mb-2 p-0">
            <SearchInput
            label="Código:"
            autoComplete="off"
            disabled
            ref={txtIdOpeInv}
            name="idopeinv"
            onKeyUp={handleInputNumeroChange}
            onBlur={handleInputNumeroChange}
            onClickButton={() => setCatalogoOpeInv(true)}
            disabledButton={habilitarCat}
            />
        </div>
        <div className="col-4 m-0 mb-2 p-0 pl-4">
            <Input
            label="Fecha de Ingreso:"
            type="date"
            disabled={!habilitado}
            ref={txtFecha}
            max={moment.utc(fechaSistema).format("YYYY-MM-DD")}
            name="fechaope"
            onKeyUp={handleInputChange}
            onBlur={handleInputChange}
            />
        </div>
        <div className="col-4 m-0 mb-2 p-0 pl-4">
            <Select
            label="TIPO DE OPERACION:"
            disabled={!habilitadoM}
            ref={cmbTipoOperacion}
            name="tipoopeinv"
            onChange={onChange}
            >
            <option value="1">INGRESO</option>
            <option value="2">SALIDA</option>
            <option value="3">TRASLADO</option>
            </Select>
        </div>
        <div className="col-12 m-0 mb-2 p-0">
            <Textarea
            label="Observación:"
            disabled={!habilitado}
            maxLength="500"
            style={{ height: 50 }}
            autoComplete="off"
            ref={txtObservacion}
            />
        </div>

        <fieldset className="col-12 m-0 p-2 d-flex align-items-center gap-4 border-azul rounded">
            <legend className="float-none w-auto fw-bold m-0">
            Almacen {visibleAlma !== "hidden" && "Origen"}
            </legend>
            <div className="col-4 m-0 p-0">
            <SearchInput
                label="Código:"
                //disabled={!habilitadoM}
                disabled
                ref={txtCodAlmaOrigen}
                autoComplete="off"
                name="codalmaorigen"
                onKeyUp={handleInputNumeroChange}
                onBlur={handleInputNumeroChange}
                onClickButton={() => {
                setCualCat(1);
                setCatalogoAlmacen(true);
                }}
                //disabledButton={!habilitado}
                disabledButton
            />
            </div>
            <div className="col m-0 p-0">
            <Input
                label="Descripción:"
                disabled
                ref={txtDescripAlmaOrigen}
            />
            </div>
        </fieldset>

        {visibleAlma !== "hidden" && (
            <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex gap-4">
            <legend className="float-none w-auto fw-bold">
                Almacen Destino
            </legend>
            <div className="col-4 m-0 p-0">
                <SearchInput
                label="Código:"
                disabled={!habilitadoM}
                ref={txtCodAlmaDestino}
                name="codalmadestino"
                onKeyUp={handleInputNumeroChange}
                onBlur={handleInputNumeroChange}
                onClickButton={() => {
                    setCualCat(2);
                    setCatalogoAlmacen(true);
                }}
                disabledButton={!habilitado}
                />
            </div>
            <div className="col m-0 p-0">
                <Input
                label="Descripción:"
                disabled
                ref={txtDescripAlmaDestino}
                />
            </div>
            </fieldset>
        )}
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-end">
            <PrimaryButton
            icon="fa-plus"
            disabled={!habilitado}
            onClick={gestionOper(1, 0, 0)}
            >
            Incluir Producto
            </PrimaryButton>
        </div>
        <div className="col-12 m-0 p-0">
            <TblContainer>
            <TblHead />
            <tbody>
                {records &&
                records.map((item, index) => (
                    <tr
                    key={item.idproducto}
                    style={{ padding: "0", fontSizeAdjust: "0.6" }}
                    >
                    <td
                        className="align-middle bg-light text-center p-0"
                        style={{ width: "40px" }}
                    >
                        {item.codigo}
                    </td>
                    <td
                        className="align-middle bg-light text-center p-0 pl-2"
                        style={{ width: "50px" }}
                    >
                        {item.descripcion}
                    </td>
                    <td
                        className="align-middle bg-light text-center p-0 pr-2"
                        style={{ width: "30px" }}
                    >
                        {formatMoneda(
                        item.cantidad
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                        ",",
                        ".",
                        2
                        )}
                    </td>

                    <td
                        className="align-middle bg-light text-center p-0"
                        style={{ width: "50px" }}
                    >
                        {item.fechavencimiento === ""
                        ? ""
                        : moment.utc(item.fechavencimiento).format(
                            "DD/MM/YYYY"
                            )}
                    </td>
                    <td
                        className="align-middle bg-light text-center p-0"
                        style={{ width: "50px" }}
                    >
                        {item.tipomovimiento}
                    </td>
                    <td
                        className="align-middle bg-light text-center p-0"
                        style={{ width: "50px" }}
                    >
                        {item.fechatipomovimiento === ""
                        ? ""
                        : moment.utc(item.fechatipomovimiento).format(
                            "DD/MM/YYYY"
                            )}
                    </td>
                    <td
                        className="align-middle bg-light text-center p-0"
                        style={{ width: "50px" }}
                    >
                        {item.numfactura}
                    </td>
                    <td
                        className="align-middle bg-light text-center p-0"
                        style={{ width: "20px" }}
                    >
                        <button
                        disabled={!habilitado}
                        style={{
                            visibility:
                            (operacion === 4 || operacion === 3) &&
                            "collapse",
                        }}
                        onClick={gestionOper(3, item.idproducto, index)}
                        className="btn btn-sm btn-danger"
                        >
                        <i className="fa fa-trash"></i>
                        </button>
                    </td>
                    </tr>
                ))}
            </tbody>
            </TblContainer>
        </div>

        {visibleBtn === "visible" && (
            <div className="col-12 m-0 mt-2 p-0 d-flex justify-content-end gap-2">
            <PrimaryButton
                icon="fa-plus"
                ref={btnIncluir}
                onClick={onBotones(1)}
                disabled={!habilitadoBot}
            >
                Incluir
            </PrimaryButton>
            <InfoButton
                icon="fa-eye"
                ref={btnConsultar}
                onClick={onBotones(4)}
                disabled={!habilitadoBot}
            >
                Consultar
            </InfoButton>
            <WarningButton
                icon="fa-edit"
                ref={btnEditar}
                onClick={onBotones(2)}
                disabled={!habilitadoBot}
            >
                Modificar
            </WarningButton>
            <DangerButton ref={btnEliminar} onClick={onBotones(3)}>
                Eliminar
            </DangerButton>
            </div>
        )}

        {visibleBtn !== "visible" && (
            <div className="col-12 m-0 mt-2 p-0 d-flex justify-content-end gap-2">
            <InfoButton icon = "fa-print"
                onClick={imprimirReporte}
                disabled={operacion === 4 ? false : true}
            >
                Imprimir
            </InfoButton>

            <SuccessButton 
                disabled={habilitadoBot}
                onClick={onBotones(5)}
                ref={btnAceptar}
            >
                Aceptar
            </SuccessButton>
            <DangerButton
                disabled={habilitadoBot}
                onClick={onBotones(6)}
                ref={btnCancelar}
            >
                Cancelar
            </DangerButton>
            </div>
        )}
        </div>
      <IncluirProducOper
        show={mostrar}
        onHideCancela={closeGestionOper}
        onHideAcepta={closeAceptarGestionOper}
        operacion={operacionOper}
        idalmacen={
          txtCodAlmaOrigen.current ? txtCodAlmaOrigen.current.value : ""
        }
        idalmacendest={
          txtCodAlmaDestino.current ? txtCodAlmaDestino.current.value : ""
        }
        tipoingreso={tipoIngreso}
        tipoope={
          cmbTipoOperacion.current
            ? parseInt(cmbTipoOperacion.current.value)
            : ""
        } 
       tipo={2}
        productos={records}
        registro={regDet}
        moneda={moneda}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} inverted></Dimmer>
      <CatalogoAlmacen
        show={catalogoAlmacen}
        onHideCancelar={() => setCatalogoAlmacen(false)}
        onHideAceptaCatalogo={onCatalogoAlmacen}
      />
      <CatalogoOperacionesInventario
        show={catalogoOpeInv}
        onHideCancelar={() => setCatalogoOpeInv(false)}
        onHideAceptaCatalogo={onCatalogoOperacionInv}
        idalmacen={
          txtCodAlmaOrigen.current ? txtCodAlmaOrigen.current.value : ""
        }
      />
    </div>
  );
};
export default TablaOperInventario;
